import { render, staticRenderFns } from "./PSwitch.vue?vue&type=template&id=836066b2"
import script from "./PSwitch.vue?vue&type=script&lang=js"
export * from "./PSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports